import {Module} from "vuex"
import {RooteState} from "@/store/index";

export interface TokenState{
  accessToken: string,
  refreshToken: string,
  isSuperAdmin: boolean
  role: string
}

export const token: Module<TokenState, RooteState> = {
  namespaced: true,
  state: () => ({
    accessToken: "",
    refreshToken: "",
    isSuperAdmin: false,
    role: ""
  }),
  mutations: {
    setToken(state, token){
      state.accessToken = token
    },
    setRefreshToken(state, token){
      state.refreshToken = token
    },
    setIsSuperAdmin(state, isSuperAdmin) {
      state.isSuperAdmin = isSuperAdmin
    },
    setRole(state, role) {
      state.role = role
    }
  },
}